module.exports = __webpack_public_path__ + "static/media/image_camera.957f7720.svg";